import { Button, IconArrowLineDown, csx, useToast } from '@vtex/admin-ui'
import { useMemo } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'

import { useAdmin } from '@vtex/raccoon-next'
import { Event } from 'typings'
import { useAnalytics } from 'use-analytics'
import { exportToCsv } from '../../utils/export'
import { statusMessages } from '../Table/Columns'
import { headerMessages } from '../Table/Columns/Headers'
import { getStatusInfo } from '../status'
import { usePromotionsListState } from '../usePromotionsListState'

const messages = defineMessages({
  export: { id: 'admin/promotions.list.export' },
  exportStarted: { id: 'admin/promotions.list.export.start' },
  exportSuccess: { id: 'admin/promotions.list.export.success' },
})

export function Export() {
  const { account } = useAdmin()
  const { formatMessage } = useIntl()
  const { track } = useAnalytics()
  const showToast = useToast()
  const {
    tableState: { data, status },
  } = usePromotionsListState()

  const columns = useMemo(
    () =>
      [
        'ID',
        formatMessage(headerMessages.name),
        formatMessage(headerMessages.beginDate),
        formatMessage(headerMessages.endDate),
        formatMessage(headerMessages.status),
      ].join('\t'),
    [formatMessage]
  )

  const handleExport = () => {
    showToast({
      variant: 'info',
      message: formatMessage(messages.exportStarted),
      duration: 3000,
      key: 'export',
    })

    setTimeout(() => {
      const rows = data.map((promotion) =>
        [
          promotion.id,
          promotion.name,
          promotion.beginDate,
          promotion.endDate,
          formatMessage(statusMessages[getStatusInfo(promotion).id]),
        ].join('\t')
      )

      exportToCsv([columns, ...rows])

      track(Event.PROMOTIONS_EXPORTED, { quantity: rows.length })

      setTimeout(
        () =>
          showToast({
            variant: 'positive',
            message: formatMessage(messages.exportSuccess),
            dismissible: true,
            key: 'export',
          }),
        700
      )
    }, 700)
  }

  return (
    <Button
      icon={
        <IconArrowLineDown
          className={csx({ marginRight: '0.5rem !important' })}
        />
      }
      iconPosition="start"
      variant="neutralTertiary"
      onClick={handleExport}
      disabled={status !== 'ready'}
    >
      <FormattedMessage id="admin/promotions.list.export" />
    </Button>
  )
}
